import * as React from 'react';
import AceEditor from 'react-ace';

import 'brace/theme/chrome';
import 'brace/mode/json';
import 'brace/mode/liquid';
import 'brace/mode/text';
import 'brace/mode/html';

import {isBinaryFile} from '../_util';

const EXTENSION_TO_MODE: {[ext: string]: string} = {
	json: 'json',
	template: 'liquid',
	formula: 'liquid',
	html: 'html',
	liquid: 'liquid',
};

const DEFAULT_MODE = 'text';

const DEFAULT_FONT_SIZE = 12;

function getMode(path: string) {
	const ext: string = path.split('.').pop();
	return EXTENSION_TO_MODE[ext] || DEFAULT_MODE;
}

interface CodeEditorProps {
	editing: ConfigEditor.AssetEditorState;
	fontSizeAdjustment: number;
	onChange(contents: string): void;
}

export default class CodeEditor extends React.Component<CodeEditorProps, {}> {

	public render() {
		return <div className='asset-contents'>
			<AceEditor
				key={this.props.editing.path}
				width='100%'
				height='100%'
				theme='chrome'
				fontSize={DEFAULT_FONT_SIZE + this.props.fontSizeAdjustment}
				mode={getMode(this.props.editing.path)}
				name={this.props.editing.path}
				value={this.getEditorContents()}
				onChange={this.props.onChange}
				showPrintMargin={false}
				editorProps={{$blockScrolling: Infinity}}
				readOnly={isBinaryFile(this.props.editing.path)}
				tabSize={2}
			/>
		</div>;
	}

	private getEditorContents() {
		const {path, contents} = this.props.editing;
		if (isBinaryFile(path)) {
			return 'To view this file, download it by clicking on the file name above.';
		} else {
			return contents;
		}
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-editor/util/CodeEditor.tsx